// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"642":"d365e8d8","751":"b047924d"}[chunkId] + ".css";
};